import { InstrumentImportResult } from 'entities/instrument_import_result';

import { ViewModel } from '.';

export class InstrumentImportResultViewModel extends ViewModel<InstrumentImportResult> {}
